"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var kendo_react_common_1 = require("@progress/kendo-react-common");
var Enums_1 = require("./interfaces/Enums");
exports.CardActions = function (props) {
    return (React.createElement("div", { style: props.style, className: kendo_react_common_1.classNames('k-card-actions', props.className, "k-card-actions-" + props.layout, props.orientation !== Enums_1.cardOrientation.VERTICAL ? 'k-card-actions-horizontal' : 'k-card-actions-vertical') }, props.children));
};
exports.CardActions.propTypes = {
    layout: PropTypes.oneOf(['stretched', 'start', 'center', 'end']),
    orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};
exports.CardActions.defaultProps = {
    layout: Enums_1.cardActionsLayout.START,
    orientation: Enums_1.cardOrientation.HORIZONTAL
};
